export default {
	brands: "Marcas",
	mystery_shopper: "Cliente Oculto",
	of_the_points: "de los puntos",
	photos: "Fotos",
	practice_display_and_recommend_products_with_intel_tecnology_and_you_can_redeem_the_best_prizes: "Con el programa Intel Te Premia, podrás acumular puntos y canjearlos por todo un universo de premios y beneficios. ¡Ve a por ello!",
	processors: "Procesadores",
	product_types: "Tipos de Producto",
	pts: "pts.",
	score: "Puntos",
	training_kpi_points: "Entrenamiento",
	trainings_kpi: "Entrenamiento KPI",
	trainings_non_kpi: "Entrenamiento non KPI"
}